import { useRef } from 'react'
import { useInView } from 'framer-motion'
import { useCountUp } from '../../hooks/useCountUp'

interface MetricCounterProps {
  value: number
  suffix?: string
  prefix?: string
  label: string
  decimals?: number
  duration?: number
}

export function MetricCounter({ value, suffix = '', prefix = '', label, decimals = 0, duration = 2000 }: MetricCounterProps) {
  const ref = useRef<HTMLDivElement>(null)
  const isInView = useInView(ref, { once: true, amount: 0.5 })
  const { count } = useCountUp({ end: value, duration, startOnMount: isInView, decimals })

  return (
    <div ref={ref} className="text-center">
      <div className="text-4xl md:text-5xl font-semibold text-gradient tabular-nums">
        {prefix}
        {count}
        {suffix}
      </div>
      <div className="mt-2 text-sm text-text-secondary">{label}</div>
    </div>
  )
}
